"use strict";
//  Copyright 2018, Venkat Peri.
//
//  Permission is hereby granted, free of charge, to any person obtaining a
//  copy of this software and associated documentation files (the
//  "Software"), to deal in the Software without restriction, including
//  without limitation the rights to use, copy, modify, merge, publish,
//  distribute, sublicense, and/or sell copies of the Software, and to permit
//  persons to whom the Software is furnished to do so, subject to the
//  following conditions:
//
//  The above copyright notice and this permission notice shall be included
//  in all copies or substantial portions of the Software.
//
//  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
//  OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
//  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
//  NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
//  DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
//  OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
//  USE OR OTHER DEALINGS IN THE SOFTWARE.
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @hidden
 */
var Deferred = /** @class */ (function () {
    /**
     * Creates a new Deferred object
     */
    function Deferred() {
        /**
         *  A method to resolve the associated Promise with the value passed.
         * If the promise is already settled it does nothing.
         *
         * @param  value - this value is used to resolve the promise
         * If the value is a Promise then the associated promise assumes the state
         * of Promise passed as value.
         */
        this.resolve = function () {
            throw new Error("Not initialized");
        };
        /**
         *  A method to reject the associated Promise with the value passed.
         * If the promise is already settled it does nothing.
         *
         * @param reason: the reason for the rejection of the Promise.
         * Generally its an Error object. If however a Promise is passed, then the
         *     Promise itself will be the reason for rejection no matter the state
         *     of the Promise.
         */
        this.reject = function () {
            throw new Error("Not initialized");
        };
        this.completed = false;
        var that = this;
        this.promise = new Promise(function (resolve, reject) {
            that.resolve = resolve;
            that.reject = reject;
        });
        this.promise.then(function () {
            that.completed = true;
        }).catch(function () {
            that.completed = true;
        });
    }
    /**
     * Return a Deferred in already resolved state
     *
     * @param value
     * @return {Deferred<T>}
     */
    Deferred.resolved = function (value) {
        var d = new Deferred();
        d.resolve(value);
        return d;
    };
    /**
     * Returns a Deferred in already rejected state
     *
     * @return {Deferred<T>}
     * @param reason
     */
    Deferred.rejected = function (reason) {
        var d = new Deferred();
        d.reject(reason);
        return d;
    };
    /**
     * Attaches a callback for only the rejection of the Promise.
     * @returns {Promise<T | R>} Promise for the completion of the callback.
     * @param onRejected handles rejection
     */
    Deferred.prototype.catch = function (onRejected) {
        return this.promise.catch(onRejected);
    };
    /**
     * Attaches callbacks for the resolution and/or rejection of the Promise.
     * @returns {Promise<R1 | R2>} Promise for the completion of which ever
     *     callback is executed.
     * @param onFulfilled handles fulfillment
     * @param onRejected handles rejection
     */
    Deferred.prototype.then = function (onFulfilled, onRejected) {
        return this.promise.then(onFulfilled, onRejected);
    };
    return Deferred;
}());
exports.default = Deferred;
//# sourceMappingURL=Deferred.js.map